export const INITIAL_PROFILE = {
  id: 'me',
  username: 'nuevo_chef',
  display_name: 'Mi Perfil',
  bio: '¡Hola! Estoy empezando mi aventura culinaria en Recetik.',
  avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Chef',
  dietary_preferences: [],
  allergens: [],
  following_count: 0,
  followers_count: 0
};

export const DIETARY_OPTIONS = ['Vegano', 'Vegetariano', 'Keto', 'Paleo', 'Sin Gluten'];
export const ALLERGEN_OPTIONS = ['Lácteos', 'Frutos Secos', 'Mariscos', 'Huevo', 'Soya', 'Gluten'];
export const DIFFICULTY_LEVELS = ['Fácil', 'Media', 'Difícil'];
export const TIME_RANGES = ['< 15 min', '15-30 min', '30-60 min', '> 60 min'];
export const CUISINE_TYPES = ['Italiana', 'Mexicana', 'Asiática', 'Mediterránea', 'Postres', 'Española', 'Americana', 'Francesa'];

export const COOKING_TIPS = [
  'Prueba siempre tu comida antes de servir.',
  'Mantén tus cuchillos afilados para mayor seguridad.',
  'Limpia mientras cocinas para ahorrar tiempo.'
];
